import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function SurveyMode({ state, updateState }: IProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var index = Number.parseInt((event.target as HTMLInputElement).value)
        const newStart = index == 0 ? state.startYear : state.startYear < 2000 ? 2000 : state.startYear;
        const newEnd = index == 0 ? state.endYear : state.endYear < 2001 ? 2001 : state.endYear;
        updateState({
            mode: index,
            startYear: newStart,
            endYear: newEnd
        })
    }

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Typography>Survey Mode</Typography>

            <Grid size={12}>
                <RadioGroup onChange={handleChange} value={state.mode}>
                    <FormControlLabel
                        key={0}
                        value={0}
                        control={<Radio />}
                        label={"Vehicles Only"}
                    />
                    <FormControlLabel
                        key={1}
                        value={1}
                        control={<Radio />}
                        label={"Multi-Modal"}
                    />
                </RadioGroup>
            </Grid>
        </Grid>
    )
}
